import React from 'react';

// It is hard to apply a "focus-ring" that follows the shape of the `clip-path`.
// This stroke component matches the shape of the `clip-path`, but is adjusted
// for a scalable `stroke`. It is fine to render this asset multiple times.
export function TickStrokePath() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" preserveAspectRatio="none">
            <path d="M8.139.5h9.826c1.056 0 1.779 1.009 1.457 1.968L14.284 17.78a2.546 2.546 0 0 1-2.422 1.719H2.035C.979 19.5.256 18.491.578 17.532L5.716 2.22A2.546 2.546 0 0 1 8.14.5Z" />
        </svg>
    );
}
